import { GAME_ID } from 'a/curiosoCrossing/data/constants';
import Env from '../../../../lib/Env';

const initState = {
  isDev: Env.isDevEnv,
  isOnboardingOff: false,
  round: false,
  isImmortal: false,
};

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case 'DEBUG_SET_ROUND':
      return {
        ...state,
        round: payload,
      };

    case 'DEBUG_SET_ONBOARDING':
      return {
        ...state,
        isOnboardingOff: payload,
      };

    case 'DEBUG_SET_IMMORTALITY':
      return {
        ...state,
        isImmortal: payload,
      };

    default:
      return state;
  }
};

export default screenReducer;
